export const categories = ['CATEGORY', 'ASN', 'ASN_DEFAULT'];

export const marginListColumns = [
  {
    title: 'Margin Type',
    dataIndex: 'marginType',
    key: 'marginType',
  },
  {
    title: 'Start Date & Time',
    dataIndex: 'startDateTime',
    key: 'startDateTime',
  },
  {
    title: 'End Date & Time',
    dataIndex: 'endDateTime',
    key: 'endDateTime',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
];

export const pageItems = [
  15,
  25,
  50
]

export const errorColor = '#f44336';
export const successColor = '#4caf50';